export default __webpack_public_path__ + "static/media/insights-empty-range-grayscale.f2432f0b.svg";